// CompactIconButton — the 36px icon-only control (brand compact scale,
// `controlHCompact`) for an action that sits INSIDE another control's row:
// a pill field's send action, a row's copy action.
//
// UI-INVITE-MODAL-CONTROL-SIZE-1 (measured live on prod, 2026-09-07): the
// invite row's send button and the magic-link copy button painted 62px and
// 60px circles inside a 49px input. Both extended two Button descendants at
// once (`['CanvasButton', 'IconButton']`, `['CanvasButton', 'CopyButton']`)
// and came out with the Button atom's 44px `controlH` floor — SquareButton's
// `minHeight: 'auto'` reset never reached them through that stack — and
// then a `Y2` call-site padding on a content-box grew the box further. Only
// three buttons on the whole page carried the 44px floor: those two and the
// (intended) 44px AllMembersBtn. Rule 68: a control's geometry is stated
// ONCE, on its primitive — this one pins width, height, padding, box model
// AND min-height itself, and every consumer extends exactly this one name
// (a single `extends` string, never a pair).
//
// Theme is the consumer's: `primary` for the ONE primary action of a row
// (solid ink, never a hue fill — brand law), the inherited `tertiary` for a
// quiet action. Icon: `icon: '<name>'` at the call site, as on every
// IconText descendant.
//
// THE ICON-BUTTON LAW, staged (Nika 2026-09-26: "all icon buttons should have
// 1/1 aspect ratio"; DESIGN-WL-ICON-BUTTONS-SQUARE-1). Brand IconButton carries
// the law from company 5abaf75 (design-d1): an icon-only button is a square —
// controlHCompact, aspect-ratio 1 / 1, padding 0, flex-shrink 0, border-box,
// the glyph centred. Until that brand is published and pinned, THIS is the
// kit's square: every kit icon-only control extends it, so dev shows the law
// now. Its geometry is locked to brand's `.isIconOnly` values
// (__tests__/iconButtonSquare.test.js) — the two cannot drift, and once the
// pinned brand carries the law the declarations here restate it, never fight
// it.
export const CompactIconButton = {
  extends: ['IconButton', 'AppControl'],
  compact: true,
  boxSize: 'controlHCompact',
  minHeight: 'controlHCompact',
  aspectRatio: '1 / 1',
  boxSizing: 'border-box',
  padding: '0',
  round: 'radiusPill',
  flexShrink: '0',
  align: 'center center',
  cursor: 'pointer',
  Icon: {
    boxSize: 'iconSm',
    display: 'block',
    flexShrink: '0'
  }
}
